// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__34vh5","content":"LoadingAlert_content__27OBy"};